import { Component, Input } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.less']
})
export class RibbonComponent {
  @Input() ribbon;
  private breakPoints = environment.features.posterType == "v" ? {
    0: {
      slidesPerView: 3.5,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 5
    },
    768: {
      slidesPerView: 6.5,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 10
    },
    992: {
      slidesPerView: 7.5,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 15
    },
    1920: {
      slidesPerView: 8.5,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 15
    }
  } : {
    0: {
      slidesPerView: 1.5,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 5
    },
    768: {
      slidesPerView: 4.5,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 10
    },
    992: {
      slidesPerView: 5.5,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 15
    },
    1920: {
      slidesPerView: 6.5,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 15
    }
  };

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 8.5,
    spaceBetween: 15,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    slidesOffsetBefore: 64,
    slidesOffsetAfter: 15,
    watchOverflow: true,
    breakpoints: this.breakPoints
  };
  constructor() { }

  /** Change location to explore ribbon */
  explore(ribbon) {
    location.hash = (ribbon.hasChildren ? "#/catalogs/" : "#/catalog/") + ribbon.id;
  }
}